import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { CreateFolder } from "./CreateFolder";
import { newAuthService } from "Service/Axios";
import {
  deleteRulesFolderUrl,
  getRulesFolderListUrl,
  getRulesListUrl,
} from "Constant/api";
import { paths } from "Constant/paths";

export default function AdminRules() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [showCreateFolder, setShowCreateFolder] = useState(false);
  const [selectedFolder, setSelectedFolder] = useState(null);
  const [activeFolder, setActiveFolder] = useState(null);
  const [folderList, setFolderList] = useState([]);
  const [rulesList, setRulesList] = useState([]);

  const toggleCreateFolder = (folder = null) => {
    setShowCreateFolder(!showCreateFolder);
    setSelectedFolder(folder);
  };

  const handleChangeFolder = (folderId) => {
    setActiveFolder(folderId);
  };

  const fetchFolderList = async () => {
    setLoading(true);
    const payload = {};
    const response = await newAuthService(
      getRulesFolderListUrl,
      "POST",
      payload
    );
    if (response.status && response.data && response.data.length > 0) {
      const firstFolderId = response.data[0].gid;
      setActiveFolder(firstFolderId);
      setFolderList(response.data);
      fetchRulesList(firstFolderId);
    } else {
      setActiveFolder(null);
      setFolderList([]);
      setLoading(false);
    }
  };

  const fetchRulesList = async (folderId) => {
    setLoading(true);
    const payload = { folderId };
    const response = await newAuthService(getRulesListUrl, "POST", payload);
    if (response.status && response.data && response.data.length > 0) {
      setRulesList(response.data);
      setLoading(false);
    } else {
      setRulesList([]);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFolderList();
  }, []);

  const onDeleteFolder = async (folderGid) => {
    try {
      const data = {
        gid: folderGid,
      };
      const response = await newAuthService(deleteRulesFolderUrl, "POST", data);
      if (response.status && response.data.success) {
        fetchFolderList();
        toast.success(t("common.messages.notification.success.deleteFolder"));
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      toast.error(t("common.messages.notification.failed.somethingWentWrong"));
    }
  };

  return (
    <main className="main">
      <div className="formbuilder-wrapper">
        <div className="d-flex flex-wrap">
          {/* Sidebar Navigation */}
          <div className="formbuilder-navigation-sidebar rounded-start pb-3">
            <div className="height-equal">
              <div className="p-3">
                <div className="d-grid gap-3">
                  <button
                    type="button"
                    className="btn btn-secondary w-100"
                    onClick={() => toggleCreateFolder()}
                  >
                    <i className="bx bx-plus-circle bx-sm me-1 align-middle"></i>
                    Create New Folder
                  </button>
                </div>
              </div>
              <nav className="formbuilder-navigation">
                <ul className="m-0 p-0 d-flex flex-column height-equal">
                  {loading ? (
                    <li>
                      <a>Folder Loading...</a>
                    </li>
                  ) : folderList && folderList.length > 0 ? (
                    folderList.map((folder) => (
                      <li
                        key={folder.gid || folder.id}
                        className={`formbuilder-navigation-item ${
                          (folder.gid || folder.id) === activeFolder
                            ? "active"
                            : ""
                        }`}
                      >
                        <div
                          className="formbuilder-navigation-item-content"
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          <div>
                            <button
                              onClick={() =>
                                handleChangeFolder(folder.gid || folder.id)
                              }
                              className="folder-name-btn border-0 bg-transparent"
                            >
                              {folder.name}
                              <span className="folder-count">
                                {folder.ruleCount}
                              </span>
                            </button>
                          </div>
                          <div
                            className=""
                            style={{
                              display: "flex",
                              gap: "10px",
                              alignItems: "center",
                            }}
                          >
                            <button
                              className="p-0"
                              onClick={() => toggleCreateFolder(folder)}
                              title="Edit folder"
                            >
                              <i className="bx bx-edit-alt bx-xs"></i>
                            </button>
                            <button
                              className="p-0"
                              onClick={() => onDeleteFolder(folder.gid)}
                              title="Delete folder"
                            >
                              <i className="bx bx-trash bx-xs"></i>
                            </button>
                          </div>
                        </div>
                      </li>
                    ))
                  ) : (
                    <li>
                      <a>No folders available</a>
                    </li>
                  )}
                </ul>
              </nav>
            </div>
          </div>

          {/* Content Area */}
          <div className="formbuilder-view p-3 rounded-end bg-white">
            <div className="d-flex flex-wrap align-items-center gy-3 mb-3">
              <h5>Rules</h5>
              <div className="ms-auto">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => navigate(paths.admin.rules.create)}
                >
                  <i className="bx bx-plus-circle bx-sm me-1 align-middle"></i>
                  {t("common.button.createRule")}
                </button>
              </div>
            </div>
            <div>
              <ul className="m-0 p-0">
                {rulesList && rulesList.length > 0 ? (
                  rulesList.map((rule) => (
                    <li key={rule.id} className="list-item">
                      <span>{rule.name}</span>
                    </li>
                  ))
                ) : (
                  <li>No rules available</li>
                )}
              </ul>
            </div>
          </div>
        </div>
      </div>

      {showCreateFolder && (
        <CreateFolder
          show={showCreateFolder}
          toggle={toggleCreateFolder}
          folderData={selectedFolder}
          fetchList={fetchFolderList}
        />
      )}
    </main>
  );
}
